<template>
<v-dialog
    v-model="display"
    width="350"
    persistent>
    <v-card flat>
        <v-card-title>{{ $t('print') }}</v-card-title>
        <v-card-text>
            {{ $t('print_msg') }}
        </v-card-text>
        <v-card-actions>
            <v-btn
                @click="print"
                color="primary"
                text>
                {{ $t('print') }}
            </v-btn>
            <v-btn @click="display = false" text>
                {{ $t('close_btn') }}
            </v-btn>
        </v-card-actions>
        <div id="simulateEntriesPrint" style="display: none; font-family: 'Cairo', sans-serif">
            <div class="title">
                <h2>Simulated Entry</h2>
            </div>
            <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th>{{ $t('date') }}</th>
                        <td>{{ simulate.date }}</td>
                        <th>{{ $t('document_date') }}</th>
                        <td>{{ simulate.date}}</td>
                        <th>{{ $t('reference_no') }}</th>
                        <td>{{ simulate.reference_code }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('reference_type') }}</th>
                        <td colspan="5">{{ simulate.reference_type }}</td>
                    </tr>
                </tbody>
            </table>
            <br>
            <table style="border-collapse: collapse; border: none; " class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <!-- <th>#</th> -->
                        <th>{{ $t('account') }}</th>
                        <th>{{ $t('narration') }}</th>
                        <th>{{ $t('debit') }}</th>
                        <th>{{ $t('credit') }}</th>
                        <th>{{ $t('dimension') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(line, index) in simulate.lines" :key="index">
                        <!-- <td>{{ index + 1 }}</td> -->
                        <td>{{ line.account_name }}</td>
                        <td>{{ line.narration }}</td>
                        <td>{{ formatNumber(line.debit) }}</td>
                        <td>{{ formatNumber(line.credit) }}</td>
                        <td>{{ line.dimension_name }}</td>
                    </tr>
                    <tr class="font-weight-black">
                        <!-- <td></td> -->
                        <td></td>
                        <td>{{ $t('total') }}</td>
                        <td>{{ formatNumber(totalDebit) }}</td>
                        <td>{{ formatNumber(totalCredit) }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <br>
            <table>
                <tbody>
                    <tr>
                        <th>{{ $t('narration') }}</th>
                        <td>{{ simulate.narration }}</td>
                    </tr>
                </tbody>
            </table>
            <br>
            <div class="footer">
                <p>Auto Generated By: AICA <span>&#174;</span></p>
            </div>
        </div>
    </v-card>
</v-dialog>
</template>

<script>
import { formatNumber } from 'accounting';

export default {
    name: "SimulateEntriesPrint",
    props: ["simulate", "value"],
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        totalDebit() {
            return  this._.sumBy(this.simulate.lines, (line) => {
                return Number(line.debit);
            });
        },
        totalCredit() {
            return this._.sumBy(this.simulate.lines, (line) => {
                return Number(line.credit);
            });
        },
    },
    methods: {
        formatNumber,
        print() {
            this.$htmlToPaper("simulateEntriesPrint");
            this.display = false;
        }
    }
}
</script>